import type { ComponentProps, ComponentType } from 'react';

import { NewFundIcon } from './NewFundIcon';
import { CalendarIcon } from './ProductIcons';
import { QuestionIcon } from './QuestionIcon';
import { SuggestionIcon } from './SuggestionIcon';

export type BlogSectionSlug = 'announcements' | 'case-studies' | 'knowledge-base' | 'release-notes';

/**
 * One mark per blog section, drawn by the header's Learn menu, the footer,
 * and the blog's own pages, so a section looks the same wherever it is named.
 *
 * Ink at a shared 16px box (square root of the painted width times height):
 * speech bubble 16.0, sparkle 14.5, calendar 15.6, question mark 14.5. The
 * two smaller ones read a tenth under the bubble. Not corrected: each mark
 * is drawn at four sizes (size-4 to size-36), so a per-mark height would be
 * four numbers each, and at a tenth the set still reads as one. Re-measure
 * here before adding a fifth.
 */
export const BLOG_SECTION_ICONS: Record<BlogSectionSlug, ComponentType<ComponentProps<'svg'>>> = {
  'case-studies': SuggestionIcon,
  'announcements': NewFundIcon,
  'release-notes': CalendarIcon,
  'knowledge-base': QuestionIcon,
};
